import React from 'react';

export function DisplaySectionFragment(props) {
  const { title, children } = props;
  return (
    <div style={{ borderBottom: '3px solid rgb(212, 212, 212)', marginBottom: 16 }}>
      <h3>{title}</h3>
      <div style={{ paddingLeft: 16 }}>{children}</div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/public/journey1/fragments/sectionFragment/displaySectionFragment.js